export default from './post-share-button';



// WEBPACK FOOTER //
// ./app/components/post-share-button/index.js